import { jsx as i } from "react/jsx-runtime";
const r = ({
  headingLevel: e = "h3",
  children: t,
  ...a
}) => /* @__PURE__ */ i(e, { id: "modalTitle", className: "tit_header", ...a, children: t });
export {
  r as default
};
